/* eslint-disable */
// src/services/machineTypeService.js

import axios from "services/axiosConfig";

const API_URL = "/api/machineType";

class MachineTypeService {
  // Obtener todos los tipos de máquinas
  static async getMachineTypes() {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los tipos de máquinas:", error);
      return [];
    }
  }

  // Obtener un tipo de máquina por id
  static async getMachineTypeById(id) {
    try {
      const endpoint = `${API_URL}/${id}`;
      const response = await axios.get(endpoint); 
      return response.data;
    } catch (error) {
      console.error("Error al obtener la fórmula por ID:", error);
      return null;
    }
  }

}

export default MachineTypeService;
